var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"text-xs-center pa-4"},[_c('div',{staticClass:"subheading mb-4"},[_vm._t("title",[_vm._v(_vm._s(_vm.props.title))])],2),_c('div',{staticClass:"subheading primary--text"},[_vm._t("text",[_vm._v(_vm._s(_vm.props.text))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }